<!-- Lien d'évitement : premier élément focalisable, il permet d'atteindre le
     contenu sans traverser l'en-tête au clavier. Visible seulement au focus. -->
<a class="skip" href="#contenu">Aller au contenu</a>

@if (clientChrome()) {
  <div class="app-chrome" [class.app-chrome--collapsed]="headerCollapsed()">
    <header class="app-header">
      <div class="bar">
        <a class="brand" [routerLink]="shopSkin.skin()?.homePath ?? '/'">
          @if (shopSkin.skin(); as skin) {
            @if (skin.logoUrl) {
              <img [src]="skin.logoUrl" width="256" height="256" [alt]="skin.farmName" />
            } @else {
              <span class="farm-brand">{{ skin.farmName }}</span>
            }
            <span class="brand-slogan">Commande sécurisée par Champ’Table</span>
          } @else {
            <img src="brand/logo.png" width="256" height="256" alt="Champ'Table" />
            <span class="brand-slogan">Des producteurs près de chez vous</span>
          }
        </a>

        <nav class="chrome-nav" aria-label="Navigation principale">
          @if (!shopSkin.skin()?.chrome) {
            <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
              Accueil
            </a>
            @if (!hideSellLink()) {
              <a routerLink="/vendre" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                Vendre
              </a>
            }
          }
        </nav>

        <a
          class="header-scan"
          routerLink="/scan"
          routerLinkActive="active"
          aria-label="Scanner un QR code"
        >
          <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
            <path
              fill="currentColor"
              d="M3 3h6v2H5v4H3V3zm12 0h6v6h-2V5h-4V3zM3 15h2v4h4v2H3v-6zm16 0h2v6h-6v-2h4v-4zM7 7h4v4H7V7zm6 0h4v2h-2v2h-2V7zm-6 6h2v2H7v-2zm4 0h6v2h-2v2h-2v-2h-2v-2zm-2 4h2v2H9v-2zm8-2h2v4h-4v-2h2v-2z"
            />
          </svg>
        </a>

        <div class="session chrome-session">
          @if (cart.hasItems()) {
            <a routerLink="/panier" routerLinkActive="active" class="nav-cart">
              Panier ({{ cart.itemCount() }})
            </a>
          }
          @if (isAuthenticated()) {
            <ct-account-menu
              [email]="profile()?.email ?? ''"
              [fullName]="profile()?.fullName"
              [photoUrl]="clientMe.photoUrl()"
              [isAdmin]="profile()?.groups?.includes('admins') ?? false"
              (signedOut)="signOut()"
            />
          } @else {
            <a ctButton="primary" routerLink="/connexion" [queryParams]="signInParams()">
              Se connecter
            </a>
          }
        </div>
      </div>
    </header>

    @if (install.offer()) {
      <ct-install-banner
        [platform]="install.platform()"
        [nativeInstall]="install.canPrompt()"
        (install)="install.promptInstall()"
        (dismiss)="install.dismiss()"
      />
    }

    <ct-cart-bar class="cart-bar-host--desktop" />
  </div>

  <ct-cart-bar class="cart-bar-host--mobile cart-bar-host--legacy-mobile" />
}

<main
  id="contenu"
  class="app-main ct-paper"
  [class.app-main--cart]="clientChrome() && cart.hasItems()"
  [class.app-main--producer]="producerOps()"
  [class.app-main--client-dock]="clientChrome()"
>
  <div class="ct-container" [class.ct-container--wide]="wide()">
    <router-outlet />
  </div>
</main>

@if (producerOps()) {
  <ct-producer-nav />
} @else {
  <ct-client-nav (signedOut)="signOut()" />
  <footer class="app-footer">
    <div class="bar">
      @if (shopSkin.skin(); as skin) {
        <span>
          @if (skin.whiteLabel) {
            Commande sécurisée par Champ’Table.
          } @else {
            Chez {{ skin.farmName }} — commande sécurisée par Champ’Table.
          }
        </span>
        <nav class="legal" aria-label="Informations légales">
          <a routerLink="/">Voir d’autres producteurs</a>
          @for (doc of legalDocuments; track doc.slug) {
            <a [routerLink]="'/' + doc.slug">{{ doc.shortTitle }}</a>
          }
        </nav>
      } @else {
        <span>Des producteurs près de chez vous, payés au juste prix.</span>
        <nav class="legal" aria-label="Informations légales">
          <a routerLink="/vendre">Vous produisez ?</a>
          @for (doc of legalDocuments; track doc.slug) {
            <a [routerLink]="'/' + doc.slug">{{ doc.shortTitle }}</a>
          }
        </nav>
      }
    </div>
  </footer>
}
